import * as React from 'react';
import IconProps from '@shared/icons/types/IconProps';

function SvgHiOutlineMapPin({ size, color, ...props }: IconProps): React.JSX.Element {
	const finalSize = size !== undefined ? size : 16;
	const finalColor = color !== undefined ? color : 'currentColor';
	return (
		<svg
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 16 16"
			width={finalSize}
			height={finalSize}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8 2.6C5.56995 2.6 3.6 4.56995 3.6 7C3.6 9.16064 4.73454 10.8931 5.92924 12.1163C6.5228 12.724 7.11807 13.192 7.56494 13.5076C7.7351 13.6279 7.88296 13.7254 8 13.7997C8.11704 13.7254 8.2649 13.6279 8.43506 13.5076C8.88193 13.192 9.4772 12.724 10.0708 12.1163C11.2655 10.8931 12.4 9.16064 12.4 7C12.4 4.56995 10.4301 2.6 8 2.6ZM8 14.5C7.71177 15.0262 7.71157 15.0261 7.71134 15.026L7.70935 15.0249L7.7051 15.0226L7.69127 15.0148C7.67972 15.0083 7.66353 14.9991 7.64303 14.9872C7.60203 14.9635 7.54372 14.929 7.47057 14.8839C7.32434 14.7939 7.11838 14.6614 6.87256 14.4878C6.38193 14.1412 5.7272 13.6269 5.07077 12.9548C3.76546 11.6183 2.4 9.60079 2.4 7C2.4 3.90721 4.90721 1.4 8 1.4C11.0928 1.4 13.6 3.90721 13.6 7C13.6 9.60079 12.2345 11.6183 10.9292 12.9548C10.2728 13.6269 9.61807 14.1412 9.12744 14.4878C8.88163 14.6614 8.67566 14.7939 8.52943 14.8839C8.45628 14.929 8.39797 14.9635 8.35697 14.9872C8.33647 14.9991 8.32029 15.0083 8.30873 15.0148L8.2949 15.0226L8.29065 15.0249L8.28921 15.0257C8.28899 15.0258 8.28823 15.0262 8 14.5ZM8 14.5L8.28823 15.0262C8.10866 15.1246 7.89091 15.1244 7.71134 15.026L8 14.5ZM8 5.6C7.2268 5.6 6.6 6.2268 6.6 7C6.6 7.7732 7.2268 8.4 8 8.4C8.7732 8.4 9.4 7.7732 9.4 7C9.4 6.2268 8.7732 5.6 8 5.6ZM5.4 7C5.4 5.56406 6.56406 4.4 8 4.4C9.43594 4.4 10.6 5.56406 10.6 7C10.6 8.43594 9.43594 9.6 8 9.6C6.56406 9.6 5.4 8.43594 5.4 7Z"
				fill={finalColor}
			/>
		</svg>
	);
}
export default SvgHiOutlineMapPin;
